module.exports = __webpack_public_path__ + "static/media/L.3dc83ab7.jpg";